export default __webpack_public_path__ + "static/media/espe_logo_blanco.e90567c4.png";